export default "__VITE_ASSET__DrnJ0AuN__"